import * as Ecosystem from '../ecosystem/ecosystem';  // Ecosystem class

var token = false;
var jwt = false;

/**
 * Parse JWT token
 * @param    {string}  token  JWT token
 * @returns  {object}         Token's payload
 */
function parse(token)
{
	var base64Url = token.split('.')[1];
	var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
	var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
	return JSON.parse(jsonPayload);
}

/**
 * Get JWT token
 * @returns  {object}  Token's payload
 */
export function get()
{
	// Get and parse the token
	var newToken = Cookies.get(Ecosystem.tokenName);
	if (newToken != token)
	{
		token = newToken;
		jwt = token ? parse(token) : false;
	}

	// Return the JWT
	return jwt;
}